import { getStripeCard, getToken, parseBilling, hasRMAItem } from '../../utils/stripe';

export default function ModalCheckoutController(
  Account,
  Checkout,
  MeetingsService,
  Broadcast,
  $rootScope,
  $scope,
  $uibModalInstance,
  $timeout,
  $http,
  $q,
  $uibModal,
  params,
  isStreamMonkeyMode
) {
  'ngInject';
  // check for passed-in
  const { pd_did, pd_sid, is_upgrade } = params;

  this.loadingPromises = [];

  this.isUpgrade = is_upgrade;
  this.$timeout = $timeout;
  this.account = $rootScope.account;
  this.Account = Account;
  this.user = $rootScope.user;
  this.stripeCard = getStripeCard();
  this.$http = $http;
  this.$uibModal = $uibModal;

  this.method = 'cc';
  this.currentUpgrade = null;
  this.upgradeWaitInterval = 2000;
  this.submittingCard = false;
  this.disallowCheckout = false;
  this.disallowCheckoutReason = null;
  this.isLoading = true;
  this.allowMonthlyChecks = this.account.extra_features.allow_monthly_checks;

  this.step = 1;
  let STEP_FINAL = 6,
    STEP_AGREE = 4,
    ALLOW_ADDONS = true;
  if (isStreamMonkeyMode) {
    STEP_FINAL = 4;
    STEP_AGREE = 1;
    ALLOW_ADDONS = false;
  }

  remoteLogger.info('Opened trial self-service checkout modal', params);

  this.dismiss = () => {
    if (this.step >= STEP_FINAL) {
      // Wipe onboarding metadata, refresh app and go back to home
      Account.get((a) => {
        var newMeta = a.metadata;
        delete newMeta.onboarding_step;
        Account.update(
          {
            metadata: newMeta,
          },
          () => {
            window.location.href = '/';
          }
        );
      });
    } else {
      $uibModalInstance.dismiss('cancel');
    }
  };

  // don't let user use this dialog once they're off their trial
  if (this.account.contract == 'recurring' && !this.isUpgrade) {
    this.disallowCheckout = true;
    this.disallowCheckoutReason = 'already_converted';
    return;
  }

  this.storagePolicy = this.account.storage_policy;

  this.salesTaxCents = 0;
  this.shipping = {
    country: 'US',
  };

  this.addOns = [];
  if (ALLOW_ADDONS) {
    this.$http.get('/assets/add-ons.json').then((response) => {
      this.addOns = response.data;
    });
  }

  this.stripeProducts = [];
  Account.getProducts()
    .$promise.then((response) => {
      this.stripeProducts = response;
      this.boxcasterProduct =
        _.find(this.stripeProducts, {
          id: 'BXC-HDSD2',
        }) || {};
      this.boxcasterProProduct =
        _.find(this.stripeProducts, {
          id: 'BXC-PRO-2995',
        }) || {};
      this.scoreboardAssistProduct =
        _.find(this.stripeProducts, {
          id: 'BXC-SB-ASSIST',
        }) || {};
    })
    .catch((err) => {
      console.error(err);
      this.stripeProducts = [];
    });

  this.selectedBasePlan = 'experience';
  this.selectedInterval = 'annual';
  this.selectedEncoder = 'app';

  this.selectPlan = (plan) => {
    this.selectedBasePlan = plan;
    this.checkPlanCompatibility();
  };

  this.selectedPlans = () => {
    return Checkout.stripePlanIDs(
      this.selectedBasePlan,
      this.selectedInterval,
      this.selectedAddOns
    );
  };

  this.oneTimeAddOnCharges = [];

  this.selectedSkus = () => {
    return Checkout.stripeSKUs(this.selectedEncoder, this.oneTimeAddOnCharges, {
      shure_promo: this.shurePromoApplied,
    });
  };
  this.selectedBasePlanAmount = () => {
    return (
      {
        essential: 99,
        growth: 149,
        experience: 199,
      }[this.selectedBasePlan] * (this.selectedInterval == 'annual' ? 12 : 1)
    );
  };

  this.checkAddOnPrice = (addOn) => {
    let quantity = this.addOns[addOn.varName].quantity;
    if (quantity === 0) {
      quantity += 1;
    }
    const concurrentBroadcasts = this.addOns.concurrentBroadcasts;
    if (addOn.costPerStream && concurrentBroadcasts.selected) {
      quantity = quantity * (concurrentBroadcasts.quantity + this.account.max_simultaneous_streams);
    } else if (addOn.costPerStream && !concurrentBroadcasts.selected) {
      quantity = quantity * this.account.max_simultaneous_streams;
    }
    return quantity * addOn.monthlyCost * (this.selectedInterval == 'annual' ? 12 : 1);
  };

  this.scoreboardAssistPrice = (quantity) => {
    quantity -= 1;
    return quantity * 599;
  };

  // Get account upgrades
  this.loadingUpgrades = true;
  this.upgrades = Account.getUpgrades();
  this.loadingPromises.push(
    $q((resolve, reject) => {
      this.upgrades.$promise
        .then(() => {
          this.loadingUpgrades = false;
          // For each upgrade, append the actual proposal data
          $q.all(
            this.upgrades.map((u) => {
              return $http
                .get(`${INTEGRATIONS_ROOT}/pandadoc/document?pandadoc_id=${u.pandadoc_id}`)
                .then((r) => {
                  u.proposal = r.data;
                });
            })
          )
            .then(() => {
              resolve();
            })
            .catch((e) => {
              reject(e);
            });
        })
        .catch((e) => {
          reject(e);
        });
    })
  );

  this.checkPreviousSelectedPayment = () => {
    const paymentException =
      this.account.payment_method === 'check' || this.account.payment_method === 'po';
    if (Checkout.currentInterval(this.billing) === 'month' && paymentException) {
      this.showAllPaymentOptions = true;
    }
  };

  // Get account billing information from Stripe
  this.planName = '';
  this.loadingPromises.push(
    Checkout.getBilling()
      .then((r) => {
        if (
          this.account.isTrialing() &&
          (this.account.payment_method == 'po' || this.account.payment_method == 'check')
        ) {
          // PO/Check customers will be stuck in "trial" contract until they actually
          // complete payment.  Don't let them check out again.
          if (r.outstandingInvoices.length) {
            this.disallowCheckout = true;
            this.disallowCheckoutReason = 'outstanding_invoice';
          }
        }
        this.billing = r.billing;
        this.cardOnFile = r.cardOnFile;
        this.bankOnFile = r.bankOnFile;
        this.planName = Checkout.stripeBasePlanNameShortFromBillingResult(this.billing);
        this.planAmount = Checkout.stripeBasePlanAmountFromBillingResult(this.billing);
        this.interval = Checkout.currentInterval(this.billing);
        this.planLookupKey = Checkout.stripeBasePlanLookupKeyFromBillingResult(this.billing);
        // TODO: consider if we should be creating add-ons for the other plans in their Stream Monkey trial
        this.method = Checkout.paymentMethodFromAccount(this.account);
        this.checkPreviousSelectedPayment();
      })
      .catch((err) => {
        console.error(err);
        this.billing = {};
      })
  );

  // Load the current pandadoc if we have one
  this.loadProposal = () => {
    return $q.all(this.loadingPromises).then(() => {
      // See if account already has an upgrade created for them
      // Load the most recent one
      if (this.upgrades.length > 0) {
        this.currentUpgrade = this.upgrades[0];
        if (pd_did) {
          this.upgrades.forEach((u) => {
            if (u.pandadoc_id == pd_did) {
              this.currentUpgrade = u;
            }
          });
        }
        this.processDocument();
        this.restoreSelectionFromUpgradeDoc();
        this.step = STEP_AGREE;
      } else if (this.isUpgrade) {
        // If a customer is trying to view an upgrade proposal but has no upgrades on
        // their account, the upgrade they're trying to view no longer exists.
        // Skip to step 4 so a proper error message can be displayed.
        this.step = STEP_AGREE;
      }
    });
  };

  // Check on eligibility for promotion
  this.shurePromoAvailable = false;
  this.shurePromoEligible = false;
  this.shurePromoApplied = false;
  if (this.account.has_streamed) {
    this.loadingPromises.push(
      Broadcast.query({
        'filter.stream_source': 'app',
        'filter.include_archived': 'true',
        l: 50,
      }).$promise.then((r) => {
        _.each(r, (broadcast) => {
          if (broadcast.recording_duration_seconds > 0) {
            this.shurePromoEligible = true;
          }
        });
      })
    );
  }
  $q.all(this.loadingPromises).then(() => {
    // Only allow promo for accounts created after 2020-04-01
    var stripeSubCreatedAt = moment();
    if (this.billing && this.billing.subscriptions && this.billing.subscriptions.data.length) {
      stripeSubCreatedAt = moment(this.billing.subscriptions.data[0].created * 1000);
    }
    this.shurePromoAvailable =
      this.account.isTrialing() && stripeSubCreatedAt.isAfter('2020-04-01');
  });

  this.restoreSelectionFromUpgradeDoc = () => {
    try {
      var subscriptionItems = this.currentUpgrade.proposal.products.subscription_items.map(
        (item) => ({
          id: item.stripe_price.lookup_key,
          qty: item.qty,
        })
      );
      var baseItem = subscriptionItems.filter((item) => !_.contains(item.id, 'addon'));
      var parts = baseItem[0].id.split(':');
      // set base plan and interval
      if (parts.length > 1) {
        this.selectedBasePlan = parts[0].toString();
        this.selectedInterval = parts[1].toString();
      }
      // set add-on plan selections and quantities
      for (let prop in this.addOns) {
        var matchingPlan = _.find(subscriptionItems, (p) => {
          return this.addOns[prop].sku[this.selectedInterval] == p.id;
        });
        if (matchingPlan) {
          this.addOns[prop].selected = true;
          this.addOns[prop].quantity = matchingPlan.qty;
        }
      }
      //  set scoreboard assist quantity
      var invoiceItems = this.currentUpgrade.proposal.products.invoice_items.map((item) => ({
        id: item.stripe_price.lookup_key,
        qty: item.qty,
      }));
      var assists = invoiceItems.filter((item) => _.contains(item.id, 'BXC-SB-ASSIST'));
      if (assists) {
        this.addOns.scoreboard.oneTimeCost.quantity = assists[0].qty;
      }
      // set encoder
      var encoder = invoiceItems.filter((item) => _.contains(item.id, 'HDSD'));
      if (encoder[0].id == Checkout.BOXCASTER_SKU) {
        this.selectedEncoder = 'boxcaster';
      } else if (encoder[0].id == Checkout.BOXCASTER_PRO_SKU) {
        this.selectedEncoder = 'pro';
      }
    } catch (e) {}
  };

  this.loadProposalPromise = this.loadProposal();

  $q.all(this.loadingPromises).then(() => (this.isLoading = false));

  // Watch and wait for Pandadoc messages
  Checkout.registerPandadocWatcher($scope, (evt, data) => {
    if (evt == 'session_view.document.completed') {
      this.pandadocCompleted = true;
      if (this.step == STEP_AGREE) {
        this.next(); // auto-advance once finalizing agreement
      }
    }
  });

  Checkout.getLocations().then((r) => {
    this.states = r.states;
    this.countries = r.countries;
  });

  this.goto = (step) => {
    if (this.step <= step) {
      // cannot use direct clicking to go forward
      return;
    }
    if (this.currentUpgrade && !Checkout.isDocumentSelfServiceGenerated(this.currentUpgrade)) {
      // cannot go backward at all on a seller-generated document
      return;
    }
    this.step = step;
  };

  this.finalizeAddOns = () => {
    // clearing out these arrays each time someone clicks past step 3 to ensure no duplication
    this.oneTimeAddOnCharges = [];
    this.selectedAddOns = [];
    for (let prop in this.addOns) {
      var addOn = this.addOns[prop];
      if (addOn.quantity === 0) {
        addOn.quantity += 1;
      }
      // make sure they'll be charged the same price reflected on order summary by checking max streams and if they added concurrent broadcasts and adjusting quantity accordingly
      const concurrentBroadcasts = this.addOns.concurrentBroadcasts;
      if (addOn.costPerStream && concurrentBroadcasts.selected) {
        addOn.quantity =
          addOn.quantity * (concurrentBroadcasts.quantity + this.account.max_simultaneous_streams);
      } else if (addOn.costPerStream && !concurrentBroadcasts.selected) {
        addOn.quantity = addOn.quantity * this.account.max_simultaneous_streams;
      }
      // add set quantity of addOns to array for recurring charges
      if (addOn.selected) {
        for (let i = 0; i < addOn.quantity; i++) {
          this.selectedAddOns.push(addOn.sku[this.selectedInterval]);
        }
      }
      // add set quantity of one time charges associated with Add-Ons to array for one time charges
      if (addOn.selected && addOn.oneTimeCost !== '') {
        for (let i = 0; i < addOn.oneTimeCost.quantity; i++) {
          this.oneTimeAddOnCharges.push(addOn.sku.oneTime);
        }
      }
    }
    if (this.addOns.scoreboard.selected && this.addOns.scoreboard.oneTimeCost.quantity > 0) {
      this.oneTimeAddOnCharges.push('coupon:one-time:SB-ASSIST:59900');
    }
  };

  this.planCompatibleWithSelections = true;
  this.encoderCompatibleWithSelections = true;

  this.checkPlanCompatibility = () => {
    this.planCompatibleWithSelections = true;
    if (
      this.addOns.extendedDuration.selected ||
      this.addOns.captioning.selected ||
      this.addOns.smartTVApps.selected ||
      this.addOns.scoreboard.selected
    ) {
      if (this.selectedBasePlan !== 'experience') {
        this.planCompatibleWithSelections = false;
      }
    }
  };

  this.checkEncoderCompatibility = () => {
    this.encoderCompatibleWithSelections = true;
    if (this.addOns.scoreboard.selected && this.selectedEncoder == 'app') {
      this.encoderCompatibleWithSelections = false;
    }
  };

  this.resetAddOnsIfNeeded = () => {
    if (!this.planCompatibleWithSelections || !this.encoderCompatibleWithSelections) {
      for (let prop in this.addOns) {
        this.addOns[prop].selected = false;
      }
      this.planCompatibleWithSelections = true;
      this.encoderCompatibleWithSelections = true;
    }
  };

  this.next = () => {
    if (ALLOW_ADDONS) {
      if (this.step == 1 || this.step == 2) {
        this.resetAddOnsIfNeeded();
      }
      if (this.step == 3) {
        this.finalizeAddOns();
      }
    }
    this.step += 1;
  };

  this.prev = () => {
    this.step -= 1;
  };

  this.completeCheckout = () => {
    if (this.requiresPaymentSource()) {
      this.checkoutError = 'You must select a payment method before proceeding.';
      remoteLogger.info('Checkout no payment method');
      return;
    }
    if (!Checkout.validateBillingAddress(this.billing)) {
      this.checkoutError = 'Please complete your billing address before proceeding.';
      remoteLogger.info('Checkout invalid billing address');
      return;
    }
    if (
      this.needsShipping &&
      !this.shippingSameAsBilling &&
      !Checkout.validateShippingAddress(this.shipping)
    ) {
      this.checkoutError = 'Please complete you shipping address before proceeding.';
      remoteLogger.info('Checkout invalid shipping address');
      return;
    }
    if (this.method == 'cc') {
      if (this.cardOnFile || this.stripeCard) {
        // all good
      } else {
        this.checkoutError = 'Please enter a valid credit card before proceeding.';
        remoteLogger.info('Checkout invalid credit card');
        return;
      }
    }
    if (this.method == 'ach') {
      if (this.bankOnFile) {
        // all good
      } else if (this.addNewBankAccount && this.newBankOnFile) {
        // all good
      } else {
        this.checkoutError = 'Please link your bank account before proceeding.';
        remoteLogger.info('Checkout missing bank account');
        return;
      }
    }
    this.checkoutError = null;
    if (this.method == 'cc' && (this.addNewCard || !this.cardOnFile)) {
      this.submittingCard = true;
      Checkout.submitCard(this.stripeCard)
        .then((token) => {
          remoteLogger.info('Checkout got token for card');
          this.stripeToken = token.id;
          this.submittingCard = false;
          this.doPost();
        })
        .catch((err) => {
          console.error(err);
          this.checkoutError = 'Unable to process credit card. ' + err;
          this.submittingCard = false;
          remoteLogger.info('Checkout error submitting card', {
            error: err,
          });
        });
    } else {
      this.doPost();
    }
  };

  this.currentUpgradeMatchesSelection = () => {
    var proposalPlanIDs = [];
    this.currentUpgrade.proposal.products.subscription_items.forEach((item) => {
      for (let i = 0; i < item.qty; i++) {
        proposalPlanIDs.push(item.stripe_price.lookup_key);
      }
    });
    var proposalItemIDs = [];
    this.currentUpgrade.proposal.products.invoice_items.forEach((item) => {
      for (let i = 0; i < item.qty; i++) {
        proposalItemIDs.push(item.stripe_price.lookup_key);
      }
    });

    proposalPlanIDs = proposalPlanIDs.sort();
    proposalItemIDs = proposalItemIDs.sort();
    return (
      _.isEqual(proposalPlanIDs, this.selectedPlans().sort()) &&
      _.isEqual(proposalItemIDs, this.selectedSkus().sort())
    );
  };

  this.streamMonkeyTotalPriceEstimate = () => {
    if (!isStreamMonkeyMode) return null;
    if (!this.billing) return null;
    let result = 0;
    this.billing.subscriptions.data.forEach((sub) => {
      sub.items.data.forEach((item) => {
        result += item.plan.amount;
      });
    });
    return result / 100;
  };

  this.selectedPlanFeatureSummaryList = () => {
    if (!isStreamMonkeyMode) return null;
    if (!this.billing) return null;
    let result = [];

    if (this.planName == 'Experience Plan') {
      result = [
        '1080p60 video resolution',
        'Automated Scheduling',
        'Viewer Chat',
        'Unlimited Viewers',
        'Unlimited Streaming',
        'Unlimited Destinations',
        'Priority Support',
        'Adaptive Bitrate Playback',
        'Cloud Transcoding',
        'Simulated Live',
        'Two Concurrent Broadcast',
        'One-year of Storage',
        'Automated-Captioning',
        'API Documentation',
      ];
    } else if (this.planName == 'Growth Plan') {
      result = [
        '1080p video resolution',
        'Automated Scheduling',
        'Viewer Chat',
        'Unlimited Viewers',
        'Unlimited Streaming',
        'Unlimited Destinations',
        'Priority Support',
        'Adaptive Bitrate Playback',
        'Cloud Transcoding',
        'Simulated Live',
        'One Concurrent Broadcast',
        'One-year of Storage',
      ];
    } else if (this.planName == 'Essential Plan') {
      result = [
        '1080p video resolution',
        'Automated Scheduling',
        'Viewer Chat',
        'Unlimited Viewers',
        'Unlimited Streaming',
        'Unlimited Destinations',
        'Priority Support',
        'Adaptive Bitrate Playback',
        'Cloud Transcoding',
        'One Concurrent Broadcast',
        '30 Days of Storage',
      ];
    }
    this.billing.subscriptions.data.forEach((sub) => {
      sub.items.data.forEach((item) => {
        function planNameContains(str) {
          if (item.plan.id.toLowerCase().indexOf(str) >= 0) {
            return true;
          }
          if (((item.plan.metadata || {}).display_name || '').toLowerCase().indexOf(str) >= 0) {
            return true;
          }
          return false;
        }
        if (planNameContains('captioning')) {
          result.push('Live Closed Captioning');
        }
        if (planNameContains('simultaneous')) {
          result.push('Additional Concurrent Streams');
        }
        if (planNameContains('24hours')) {
          result.push('Extended Broadcast Duration');
        }
        if (planNameContains('ticketing')) {
          result.push('Ticketing');
        }
      });
    });
    return result;
  };

  this.createProposalIfNecessary = () => {
    this.isLoadingProposal = true;
    this.pandadocError = null;
    this.loadProposalPromise.then(() => {
      if (
        (isStreamMonkeyMode && this.pandadocCompleted) ||
        (this.currentUpgrade && this.currentUpgradeMatchesSelection())
      ) {
        this.isLoadingProposal = false;
        return;
      }
      // Create new upgrade and wait for it to be processed
      let params = {
        stripe_plan_ids: this.selectedPlans(),
        stripe_sku_ids: this.selectedSkus(),
      };
      if (isStreamMonkeyMode) {
        // XXX: Note that Stream Monkey trial conversion customers use different
        // logic; we simply map their existing trial plans over, and we never
        // deal with hardware SKUs
        params = {
          stripe_plan_ids: [],
        };
        this.billing.subscriptions.data.forEach((sub) => {
          sub.items.data.forEach((item) => {
            params.stripe_plan_ids.push(item.price.lookup_key);
          });
        });
      }

      if (this.shurePromoApplied) {
        params.pandadoc_template = Checkout.PANDADOC_TEMPLATE_FREE_TRIAL_WITH_PROMO;
      } else {
        params.pandadoc_template = Checkout.PANDADOC_TEMPLATE_FREE_TRIAL;
      }
      this.currentUpgrade = null;
      Account.createUpgrade(
        params,
        (upgrade) => {
          this.waitForNewUpgrade(upgrade.id, true);
          remoteLogger.info('Trial self-service checkout created new upgrade', {
            upgrade_id: upgrade.id,
          });
        },
        (err) => {
          remoteLogger.error('Unable to create pandadoc', {
            error: err,
          });
          this.pandadocError = 'could_not_create_upgrade';
          this.isLoadingProposal = false;
        }
      );
    });
  };

  this.isPandadocCompleted = () => {
    if (this.pandadocCompleted) {
      return true;
    } else if (!this.currentUpgrade || !this.currentUpgrade.proposal) {
      return false;
    } else {
      return this.currentUpgrade.proposal.status == 'document.completed';
    }
  };

  this.waitForNewUpgrade = (upgrade_id, reset) => {
    if (reset) {
      this.waitCounter = 0;
    }
    if (this.waitCounter++ > 10) {
      this.pandadocError = 'could_not_create_upgrade';
      this.isLoadingProposal = false;
      remoteLogger.error('Trial self-service checkout timeout waiting for upgrade', {
        upgrade_id,
      });
      return;
    }
    Account.getUpgrades().$promise.then((upgrades) => {
      upgrades.forEach((u) => {
        if (u.pandadoc_id == upgrade_id) {
          this.currentUpgrade = u;
          $http
            .get(
              `${INTEGRATIONS_ROOT}/pandadoc/document?pandadoc_id=${this.currentUpgrade.pandadoc_id}`
            )
            .then((r) => {
              this.currentUpgrade.proposal = r.data;
              this.upgrades.push(this.currentUpgrade);
              this.processDocument();
            });
          this.isLoadingProposal = false;
          return;
        }
      });
      if (!this.currentUpgrade) {
        this.$timeout(() => this.waitForNewUpgrade(upgrade_id, false), this.upgradeWaitInterval);
      }
    });
  };

  this.processDocument = () => {
    this.needsShipping = false;
    this.hasNewBasePlan = !!_.find(
      this.currentUpgrade.proposal.products.subscription_items,
      (item) => {
        return !item.is_addon;
      }
    );
    this.hasSubscription = Checkout.isPurchasingSubscription(this.currentUpgrade.proposal);
    this.isRMA = false;
    this.needsShipping = false;
    if (hasRMAItem(this.currentUpgrade.proposal)) {
      this.isRMA = true;
      this.needsShipping = true;
    }
    this.loadingPromises.push(this.preview(this.currentUpgrade.pandadoc_id));
  };

  this.billingParams = () => {
    const { billing, shipping } = this;

    if (!billing || !shipping) {
      return {};
    }

    params = {
      address: billing.address,
      city: billing.city,
      state: billing.state,
      zip: billing.postal_code,
      country: billing.country,
    };
    if (this.needsShipping) {
      params = angular.extend(params, {
        ship_address: this.shippingSameAsBilling ? billing.address : shipping.address,
        ship_city: this.shippingSameAsBilling ? billing.city : shipping.city,
        ship_state: this.shippingSameAsBilling ? billing.state : shipping.state,
        ship_zip: this.shippingSameAsBilling ? billing.postal_code : shipping.postal_code,
        ship_country: this.shippingSameAsBilling ? billing.country : shipping.country,
      });
    }
    return params;
  };

  this.preview = (pandadocID) => {
    const params = {
      pandadoc_id: pandadocID,
      ...this.billingParams(),
    };
    return $http
      .put(`${API_ROOT}/account/upgrades/${this.currentUpgrade.pandadoc_id}/preview`, params)
      .then((resp) => {
        const data = resp.data;
        this.prorationDate = data.proration_date;
        this.totalNextDueCents = data.total_next_due_cents;
        this.nextDueOn = data.next_due_on;
        this.dueNow = data.due_now || [];
        this.appliedCredit = data.applied_credit;
        this.salesTaxCents = data.total_tax_cents;
        this.newInterval = data.new_interval;
        this.needsShipping = this.needsShipping || data.needs_shipping;
        this.now = Date.now();
        this.remainingCredit = 0;
      })
      .catch((err) => {
        this.pandadocError = 'could_not_preview_upgrade';
        this.isLoadingProposal = false;
        remoteLogger.error('Error previewing upgrade proration in trial self service checkout', {
          error: err,
        });
      });
  };

  this.previewDebounced = _.throttle(this.preview, 500, {
    leading: false,
  });
  $scope.$watch(
    this.billingParams,
    () => {
      if (!Checkout.validateBillingAddress(this.billing)) {
        return;
      }
      if (
        this.needsShipping &&
        !this.shippingSameAsBilling &&
        !Checkout.validateShippingAddress(this.shipping)
      ) {
        return;
      }
      this.previewDebounced(this.currentUpgrade.pandadoc_id);
    },
    true
  );

  this.calculateNextDue = () => {
    this.calculateTotalToday();
    return Math.max((this.totalNextDueCents - this.remainingCredit) / 100, 0);
  };

  this.onSelectPaymentMethod = (m) => {
    // Clear any tokens that may have been added
    this.stripeToken = null;
    if (m == 'ach' && !this.bankOnFile) {
      this.openPlaid();
    } else {
      this.method = m;
    }
  };

  this.calculateTotalToday = () => {
    let total = 0;
    _.forEach(this.dueNow, (d) => (total += d.amount_cents));
    total += this.salesTaxCents;
    total -= this.appliedCredit;
    if (total < 0) {
      this.remainingCredit = 0 - total;
      this.appliedCredit -= this.remainingCredit;
      total = 0;
    }
    return (total / 100).toFixed(2);
  };

  this.openPlaid = () => {
    Checkout.openPlaidLink().then((r) => {
      this.method = 'ach';
      this.stripeToken = r.tokenResponse.data.stripe_bank_account_token;
      this.newBankOnFile = {
        bank_name: r.metadata.institution.name,
        last4: '****',
      };
      this.addNewBankAccount = true;
    });
  };

  this.doPost = () => {
    const { $http } = this;

    let params = {
      pandadoc_id: this.currentUpgrade.pandadoc_id,
      firstname: this.user.name.split(' ')[0],
      lastname: this.user.name.split(' ')[1],
      organization_name: this.account.name,
      proration_date: this.prorationDate,
    };

    if (Checkout.isDocumentSelfServiceGenerated(this.currentUpgrade)) {
      params.transaction_type = 'upgrade_self_service';
    } else {
      params.transaction_type = 'upgrade_direct';
    }

    if (this.stripeToken) {
      params.stripe_token = this.stripeToken;
    }

    // If they have a stripe token, decide whether to use the new source for only this
    // transaction or everything going forward.
    if (
      this.stripeToken &&
      !this.changeDefaultPaymentSource &&
      this.allowDefaultPaymentSourceOverride()
    ) {
      params.payment_option = 'single_use';
    } else {
      params.payment_method = this.method;
    }

    params = angular.extend(params, this.billingParams());

    this.submitting = true;
    $http
      .put(`${API_ROOT}/account/upgrades/${this.currentUpgrade.pandadoc_id}`, params)
      .then((r) => {
        this.submitting = false;
        this.step = STEP_FINAL;
        this.waitForFinalization();
        remoteLogger.info('Successfully submitted trial self service checkout');
      })
      .catch((err) => {
        remoteLogger.error('Error submitting trial self service checkout', {
          error: err,
        });
        var error;
        if (err && err.data && err.data.error_hint) {
          error = `Unable to complete the transition. ${err.data.error_hint}`;
        } else if (err && err.data && err.data.error_description) {
          error = `Unable to complete the transition: ${err.data.error_description}`;
        } else {
          error = `An unknown error occurred while applying the changes to your account.  Please reach out to BoxCast customer support via questions@boxcast.com for assistance.`;
        }
        this.checkoutError = error;
        this.stripeToken = null; //cannot re-use
        this.submitting = false;
      });
  };

  const MAX_WAIT_FOR_FINALIZATION_MS = 60 * 1000;
  const WAIT_FOR_FINALIZATION_INTERVAL_MS = 5000;
  let startWaitForFinalization = null;
  this.waitForFinalization = () => {
    // For PO/Check, we need to poll asynchronously until the Stripe webhook
    // notifies us that the invoice was created; at that point, we'll have
    // advanced the account.contract to recurring and we can safely tell the
    // user to reload the page.
    this.waitingForFinalization = true;
    if (this.method == 'cc' || this.method == 'ach') {
      this.waitingForFinalization = false;
      return;
    }
    if (startWaitForFinalization === null) {
      startWaitForFinalization = Date.now();
    }
    if (Date.now() - startWaitForFinalization > MAX_WAIT_FOR_FINALIZATION_MS) {
      console.warn('Timed out waiting for account finalization');
      this.waitingForFinalization = false;
      return;
    }
    this.account
      .refresh()
      .then(() => {
        if (this.account.contract == 'recurring') {
          this.waitingForFinalization = false;
        } else {
          $timeout(() => this.waitForFinalization(), WAIT_FOR_FINALIZATION_INTERVAL_MS);
        }
      })
      .catch((err) => {
        console.warn('Error reloading account while waiting for finalization', err);
        $timeout(() => this.waitForFinalization(), WAIT_FOR_FINALIZATION_INTERVAL_MS);
      });
  };

  this.chatOrScheduleText = () => {
    if (window.Intercom) {
      return "Let's chat";
    } else {
      return 'Schedule a meeting';
    }
  };

  this.popChatOrSchedule = () => {
    if (window.Intercom) {
      window.Intercom('show');
    } else {
      this.dismiss();
      MeetingsService.scheduleMeeting('Schedule time to discuss other plan options');
    }
  };

  this.schedule = () => {
    this.dismiss();
    MeetingsService.scheduleMeeting('Schedule time to discuss other plan options');
  };

  this.validateCheckout = () => {
    let valid = true;
    valid = valid || Checkout.validateBillingAddress(this.billing);
    if (this.needsShipping) {
      valid = valid || Checkout.validateShippingAddress(this.shipping);
    }
    return valid;
  };

  this.changeInterval = (interval) => {
    this.selectedInterval = interval;
    if (interval == 'monthly') {
      this.method = 'cc';
      this.showAllPaymentOptions = false;
    } else {
      this.showAllPaymentOptions = false;
    }
  };

  this.allowDefaultPaymentSourceOverride = () => {
    // `single_use` sources are only applicable to invoice-item-inly orders (no subscription plan changes)
    return !this.hasSubscription && !this.account.isTrialing();
  };

  this.requiresPaymentSource = () => {
    // Verify either card/bank on file, or they've created a new source, or they're manual billing
    if (this.method == 'cc') {
      return false; //validation will be handled during submit if they explicitly opted to change to a credit card
    }
    return !(this.cardOnFile || this.bankOnFile || this.stripeToken || this.isPayingManually());
  };

  this.isChangingPaymentSource = () => {
    return this.addNewCard || this.addNewBankAccount || this.method != this.account.payment_method;
  };

  this.isPayingManually = () => {
    return this.method == 'check' || this.method == 'po';
  };

  this.checkPlanRequirements = (requiredPlan) => {
    if (requiredPlan == '' || requiredPlan == this.selectedBasePlan) {
      return true;
    } else {
      return false;
    }
  };

  this.checkEncoderRequirements = (requiredEncoder) => {
    if (requiredEncoder.length < 1) {
      return true;
    } else if (_.contains(requiredEncoder, this.selectedEncoder)) {
      return true;
    } else {
      return false;
    }
  };

  this.updateStoragePolicy = () => {
    if (this.storagePolicy == this.account.storage_policy) {
      this.next();
    } else {
      Account.update(
        {
          storage_policy: this.storagePolicy,
        },
        () => {
          this.next();
        }
      );
    }
  };

  this.finishMigration = () => {
    const newAccountData = {
      status: 'active',
    };
    if (this.storagePolicy != this.account.storage_policy) {
      newAccountData.storage_policy = this.storagePolicy;
    }
    Account.update(newAccountData, (r) => {
      $uibModalInstance.close(newAccountData);
      $rootScope.$emit('account-migrated', newAccountData);
    });
  };

  this.showDetails = false;
  this.togglePlan = 'essential';
  this.showPlanDetails = (plan, isShowing) => {
    if (this.togglePlan == plan && isShowing) {
      this.showDetails = false;
    } else {
      this.showDetails = true;
    }
    this.togglePlan = plan;
  };
}



// WEBPACK FOOTER //
// ./app/pages/settings/modal-checkout.js